module.exports = __webpack_public_path__ + "static/1-9a29baf25217fc749884b6bcf0e21991.jpg";